import { includes } from 'ramda';

import { USER_ROLES } from 'constants/general';
import collapsibleTable from 'features/common/collapsibleTable';
import fetch from 'features/common/fetch';
import { subheaders } from 'features/common/Subheader/constants';
import { setVisibleState } from 'features/common/Subheader/slice';
import { reset as resetCampaignOverview } from 'features/views/campaignDashboards/campaigns/actions';
import { actions as contactListActions } from 'features/views/contactList/actions';
import contacts from 'features/views/contacts';
import { reset as resetMarketPlace } from 'features/views/marketPlace/actions';
import { reset as resetTaskOverview } from 'features/views/taskOverview/actions';
import { getCurrentRole } from 'features/views/user/selectors';

import { COLLAPSIBLE_TABLE_NAME } from '../contactList/constants';
import { fetchCampaignManagementSummary, fetchSelectedCampaignContacts } from './campaignManagement/actions';
import { startupCampaigns } from './campaigns/actions';
import { setAllCampaigns } from './campaigns/slice';
import { fetchLeadsOverview } from './leadsOverview/actions';
import { startupDashboardMarketPlace } from './marketPlace/actions';
import { fetchSemaphoreDashboard } from './semaphore/actions';
import { fetchInfoGraphicsData, fetchLeadsSummary, fetchMyTeamSummary } from './statistics/actions';
import { toggleButtonGroupValues } from './statistics/constants';
import { setToggleValue } from './statistics/slice';
import { fetchTasksAndInformation } from './tasksAndInformation/actions';
import { startupTodaysUrgencies } from './todaysUrgencies/actions';
import { setCampaignsNearingTheEnd } from './todaysUrgencies/slice';

export const startupDashboard = () => (dispatch, getState) => {
	const currentRole = getCurrentRole(getState());

	dispatch(startupTodaysUrgencies());

	if (includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ])) {
		dispatch(fetchCampaignsSummary());
		dispatch(fetchSemaphoreDashboard());
		dispatch(startupDashboardMarketPlace());
		dispatch(startupCampaigns());
		dispatch(fetchTasksAndInformation());
		dispatch(fetchLeadsOverview());
	} else {
		dispatch(setToggleValue(toggleButtonGroupValues.MY_TEAM));
		dispatch(fetchMyTeamSummary());
		dispatch(fetchCampaignManagementSummary());
		dispatch(fetchInfoGraphicsData());
		dispatch(fetchLeadsSummary());
		dispatch(fetchSelectedCampaignContacts());
	}
};

// (marketPlace + campaingOverview + taskOverview + contacts (campaigns, campaingsNearingTheEnd))
// resetting state of complex pages when going "back via browser" to Dashboard
// called on mount of Dashboard to preserve their own logic
export const resetDashboardRelatedPages = () => (dispatch) => {
	dispatch(resetTaskOverview());

	dispatch(resetMarketPlace());
	dispatch(setVisibleState({ id: subheaders.marketPlace, visible: false }));

	dispatch(resetCampaignOverview());
	dispatch(fetch.actions.clearFetchStore(fetch.constants.urls.campaignList));

	dispatch(contacts.actions.resetContacts('list'));
	dispatch(contacts.actions.resetContacts('take'));
	dispatch(fetch.actions.clearFetchStore(fetch.constants.urls.contactList));
	dispatch(collapsibleTable.actions.removeOpenedRows(COLLAPSIBLE_TABLE_NAME));
	dispatch(contactListActions.reset());
};

// response used for CampaignsNearingTheEnd (TodaysUrgencies) and CampaignsTable (Campaigns)
export const fetchCampaignsSummary = () => (dispatch, getState) => {
	const currentRole = getCurrentRole(getState());
	const userIsSellerOrPPZ = includes(currentRole, [USER_ROLES.SELLER, USER_ROLES.PPZ]);

	userIsSellerOrPPZ &&
		dispatch(
			fetch.actions.get(fetch.constants.urls.campaignsSummary, {
				onSuccess: [
					(response) => () => {
						const { endingCampaigns = [], allCampaigns = [] } = response?.body;
						dispatch(setCampaignsNearingTheEnd(endingCampaigns));
						dispatch(setAllCampaigns(allCampaigns));
					},
				],
			}),
		);
};
